@if (hasError()) {
  <div class="flex justify-center flex-1 p-4">
    <cmi-notification
      mode="error"
      [message]="'common.notifications.errorTitle' | translate"
      [description]="'common.notifications.loadingFailed' | translate"
      [actionLabel]="'common.notifications.retry' | translate"
      (actionClick)="onReload()" />
  </div>
} @else if (isLoading()) {
  <div class="flex items-center justify-center flex-1">
    <cmi-loading-spinner />
  </div>
} @else {
  @if (!searchTerm()) {
    <ul class="grid grid-cols-2 gap-4">
      @for (tag of tags(); track tag.name) {
        <li
          class="border rounded-lg hover:bg-cmi-gray-light cursor-pointer flex flex-col text-cmi-gray items-center justify-center p-4">
          <a
            [routerLink]="['/apps', tag.name]"
            class="flex flex-col items-center justify-center w-full h-full p-4 no-underline">
            @if (tag.iconDataUrl) {
              <img
                [src]="tag.iconDataUrl"
                [alt]="'home.appAlt' | translate"
                class="w-10 h-10 mb-2" />
            }
            <span class="text-cmi-gray text-sm">{{ tag.title }}</span>
          </a>
        </li>
      }
      <li
        class="border rounded-lg hover:bg-cmi-gray-light cursor-pointer flex flex-col text-cmi-gray items-center justify-center p-4">
        <a
          [routerLink]="['/model-navigation']"
          class="flex flex-col items-center justify-center w-full h-full p-4 no-underline">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="currentColor"
            class="size-10 mb-2">
            <path
              fill-rule="evenodd"
              d="M19.253 2.292a.75.75 0 0 1 .955.461A28.123 28.123 0 0 1 21.75 12c0 3.266-.547 6.388-1.542 9.247a.75.75 0 1 1-1.416-.494c.94-2.7 1.458-5.654 1.458-8.753s-.519-6.054-1.458-8.754a.75.75 0 0 1 .461-.954Zm-14.227.013a.75.75 0 0 1 .414.976A23.183 23.183 0 0 0 3.75 12c0 3.085.6 6.027 1.69 8.718a.75.75 0 0 1-1.39.563c-1.161-2.867-1.8-6-1.8-9.281 0-3.28.639-6.414 1.8-9.281a.75.75 0 0 1 .976-.414Zm4.275 5.052a1.5 1.5 0 0 1 2.21.803l.716 2.148L13.6 8.246a2.438 2.438 0 0 1 2.978-.892l.213.09a.75.75 0 1 1-.584 1.381l-.214-.09a.937.937 0 0 0-1.145.343l-2.021 3.033 1.084 3.255 1.445-.89a.75.75 0 1 1 .786 1.278l-1.444.889a1.5 1.5 0 0 1-2.21-.803l-.716-2.148-1.374 2.062a2.437 2.437 0 0 1-2.978.892l-.213-.09a.75.75 0 0 1 .584-1.381l.214.09a.938.938 0 0 0 1.145-.344l2.021-3.032-1.084-3.255-1.445.89a.75.75 0 1 1-.786-1.278l1.444-.89Z"
              clip-rule="evenodd" />
          </svg>
          <span class="text-cmi-gray text-sm">{{ 'home.modelNavigation' | translate }}</span>
        </a>
      </li>
      @if (supportsReports()) {
        <li
          class="border rounded-lg hover:bg-cmi-gray-light cursor-pointer flex flex-col text-cmi-gray items-center justify-center p-4">
          <a
            [routerLink]="['/reports']"
            class="flex flex-col items-center justify-center w-full h-full p-4 no-underline">
            @if (reports() && reports()!.iconDataUrl) {
              <img
                [src]="reports()!.iconDataUrl"
                [alt]="'home.appAlt' | translate"
                class="w-10 h-10 mb-2" />
            } @else {
              <svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 24 24"
                fill="currentColor"
                class="size-10 mb-2">
                <path
                  fill-rule="evenodd"
                  d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm5.845 17.03a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V12a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3Z"
                  clip-rule="evenodd" />
                <path
                  d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
              </svg>
            }
            <span class="text-cmi-gray text-sm">{{ 'home.reports' | translate }}</span>
          </a>
        </li>
      }
    </ul>
  }
  @if (searchTerm()) {
    <cmi-search-results [searchTerm]="searchTerm()" (closeResults)="onCloseResults()" />
  }
}

<ng-template #footerPortal>
  <cmi-search-bar
    class="w-full"
    [searchTerm]="searchTerm()"
    (searchTermChanged)="onSearchTermChanged($event)" />
</ng-template>
